import {APP_INITIALIZER, ApplicationConfig, LOCALE_ID, provideBrowserGlobalErrorListeners} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideOAuthClient} from 'angular-oauth2-oidc';
import {AuthService} from './services/auth.service';
import {AuthInterceptor} from './interceptor/auth-interceptor';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {getFrenchPaginatorIntl} from './frenchPaginator';
import {MAT_DATE_LOCALE, provideNativeDateAdapter} from '@angular/material/core';
import {provideToastr} from 'ngx-toastr';
import {provideSweetAlert2} from '@sweetalert2/ngx-sweetalert2';
import {fr} from 'date-fns/locale';
import {registerLocaleData} from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import {provideIonicAngular} from '@ionic/angular';

export function initializeAuth(authService: AuthService): () => Promise<void> {
  return async () => {
    // Sur /callback, le CallbackComponent gère lui-même l'échange code → token.
    // Sur toute autre route (ex: /home?code=... si l'auth server n'est pas encore
    // reconfiguré), on traite le code ici pour éviter une boucle de redirections.
    const onCallbackRoute = window.location.pathname === '/callback';
    if (onCallbackRoute && authService.hasAuthCode()) {
      return;
    }

    try {
      await authService.initAuth();
    } catch (error) {
      console.error('[APP_INITIALIZER] Erreur initAuth:', error);
    }
  };
}

registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideNativeDateAdapter(),
    provideOAuthClient(),
    provideIonicAngular(),
    provideToastr({
      timeOut: 10000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }),
    // Enregistrer l'intercepteur HTTP
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: 'outline'}},
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [AuthService],
      multi: true
    },
    {provide: MatPaginatorIntl, useValue: getFrenchPaginatorIntl()},
    {provide: MAT_DATE_LOCALE, useValue: fr },
    {provide: LOCALE_ID, useValue: 'fr-FR'},
    provideSweetAlert2()
  ]
};
